import "./RaikoCustomEditor2.scss"
import RaikoEditorHtmlEditor from "./htmlEditor/RaikoEditorHtmlEditor";
import {useEffect} from "react";
import InternalImageSelector from "./internalImageSelector/InternalImageSelector";
import RaikoEditorItemsContainer from "./raikoEditorItemsContainer/RaikoEditorItemsContainer";
import InternalImageSliderSelector from "./internalImageSliderSelector/InternalImageSliderSelector";
import CreateNewItem from "./createNewItem/CreateNewItem";
import InternalVideoSelector from "./internalVideoSelector/InternalVideoSelector";
import "./RaikoCustomEditorStyleSheet.scss"
import InternalAudioSelector from "./internalAudioSelector/InternalAudioSelector";
import {RaikoErrorSection, RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";
import {RaikoErrorSectionVectors} from "../../util/RaikoErrorSectionVectors";
import {FileManagerTypes} from "../../component/fileManager/FileManager";


export default function RaikoCustomEditor2(
    {
        value = [],
        setValue,
        bucketId=FileManagerTypes.PROJECT_IMAGES.id
    }
) {


    useEffect(() => {
        console.log("text editor value is ", value)
    }, [value])

    function detectEditorValue(content, priority) {
        switch (content.type) {
            case EditorItemType.HTML:
                return <RaikoEditorHtmlEditor
                    value={content.amount}
                    editorValue={value}
                    priority={priority}
                    setEditorValue={setValue}
                />
            case EditorItemType.IMAGE:
                return <InternalImageSelector
                    value={content.amount}
                    editorValue={value}
                    priority={priority}
                    setEditorValue={setValue}
                    bucketId={bucketId}
                />
            case EditorItemType.IMAGE_SLIDER:
                return <InternalImageSliderSelector
                    value={content.amount}
                    editorValue={value}
                    priority={priority}
                    setEditorValue={setValue}
                />
            case EditorItemType.INTERNAL_VIDEO:
                return <InternalVideoSelector
                    value={content.id}
                    editorValue={value}
                    priority={priority}
                    setEditorValue={setValue}
                />
            case EditorItemType.INTERNAL_SOUND:
                return <InternalAudioSelector
                    value={content.id}
                    editorValue={value}
                    priority={priority}
                    setEditorValue={setValue}
                />
            default:
                return <div>NOT FOUND SUITABLE COMPONENT</div>
        }
    }

    return (
        <>
            <RaikoGridOneColumn className={"baseEditorContainer"}>
                {
                    value && value.length > 0 ?
                        <CreateNewItem location={-1} value={value} setValue={setValue}/>
                        : ""
                }
                {
                    value && value.length > 0 ? value.map((item, index) => {
                            return <>
                                <RaikoEditorItemsContainer value={value} setValue={setValue} priority={item.priority}>
                                    {
                                        detectEditorValue(item.content, item.priority)
                                    }
                                </RaikoEditorItemsContainer>
                                <CreateNewItem location={index} value={value} setValue={setValue}/>
                            </>
                        }) :
                        <RaikoGridOneColumn>
                            <RaikoErrorSection
                                title={"هیچ محتوایی یافت نشد"}
                                subTitle={"لطفا برای شروع یکی از محتواهای زیر را انتخاب نمایید."}
                                image={RaikoErrorSectionVectors.WRITER}
                            >
                                <div className={"firstContentLayout"}>
                                    <div className={"contentBaseLayout"}
                                         onClick={_ =>
                                             handleAddNewItem(value, setValue, EditorItemType.HTML, -1)}>
                                        <div className={"textEditorIcon-icon"}/>
                                        <span>متن</span>
                                    </div>
                                    <div className={"contentBaseLayout"}
                                         onClick={_ =>
                                             handleAddNewItem(value, setValue, EditorItemType.IMAGE, -1)}>
                                        <div className="pictureIcon-icon"/>
                                        <span>تصویر تکی</span>
                                    </div>
                                    <div className={"contentBaseLayout"}
                                         onClick={_ =>
                                             handleAddNewItem(value, setValue, EditorItemType.IMAGE_SLIDER, -1)}>
                                        <div className="sliderIcon-icon"/>
                                        <span>اسلایدر</span>
                                    </div>
                                    {/*<div className={"contentBaseLayout"}
                                         onClick={_ =>
                                             handleAddNewItem(value, setValue, EditorItemType.INTERNAL_VIDEO, -1)}>
                                        <div className="videoIcon-icon"/>
                                        <span>ویدیو</span>
                                    </div>
                                    <div className={"contentBaseLayout"}
                                         onClick={_ =>
                                             handleAddNewItem(value, setValue, EditorItemType.INTERNAL_SOUND, -1)}>
                                        <div className="soundIcon-icon"/>
                                        <span>صوت</span>
                                    </div>*/}

                                </div>

                            </RaikoErrorSection>
                        </RaikoGridOneColumn>
                }
            </RaikoGridOneColumn>
        </>
    )

}


export const EditorItemType = {
    "HTML": "HTML",
    "TEXT": "TEXT",
    "IMAGE_SLIDER": "IMAGE_SLIDER",
    "IMAGE": "IMAGE",
    "INTERNAL_VIDEO": "INTERNAL_VIDEO",
    "INTERNAL_SOUND": "INTERNAL_SOUND",
}


export function changeContent(value = [], setValue, newContent, priority) {
    const _value = []


    if (value && value.length > 0) {
        value.map((item, index) => {
            if (parseInt(item.priority) === parseInt(priority)) {
                _value.push({
                    priority,
                    ...newContent
                })
            } else {
                _value.push(item)
            }
        })
    }

    setValue(_value)
}

export function prepareEditorItem(value, type) {
    switch (type) {
        case EditorItemType.HTML:
            return {
                content: {
                    amount: value,
                    type: EditorItemType.HTML
                }
            }
        case EditorItemType.IMAGE:
            return {
                content: {
                    amount: value,
                    type: EditorItemType.IMAGE
                }
            }
        case EditorItemType.IMAGE_SLIDER:
            return {
                content: {
                    amount: value,
                    type: EditorItemType.IMAGE_SLIDER
                }
            }
        case EditorItemType.INTERNAL_VIDEO:
            return {
                content: {
                    id: value,
                    type: EditorItemType.INTERNAL_VIDEO
                }
            }
        case EditorItemType.INTERNAL_SOUND:
            return {
                content: {
                    id: value,
                    type: EditorItemType.INTERNAL_SOUND
                }
            }
    }
}

export function prepareEditorDefaultItem(type) {
    switch (type) {
        case EditorItemType.HTML:
            return {
                content: {
                    amount: "",
                    type: EditorItemType.HTML
                }
            }
        case EditorItemType.IMAGE:
            return {
                content: {
                    amount: "",
                    type: EditorItemType.IMAGE
                }
            }
        case EditorItemType.IMAGE_SLIDER:
            return {
                content: {
                    amount: [],
                    type: EditorItemType.IMAGE_SLIDER
                }
            }
        case EditorItemType.INTERNAL_VIDEO:
            return {
                content: {
                    id: -1,
                    type: EditorItemType.INTERNAL_VIDEO
                }
            }
        case EditorItemType.INTERNAL_SOUND:
            return {
                content: {
                    id: -1,
                    type: EditorItemType.INTERNAL_SOUND
                }
            }
    }
}


export function handleAddNewItem(value, setValue, type, location) {
    const _value = []

    if (value && value.length > 0 && location === -1) {
        _value.push(prepareEditorDefaultItem(type))
    }

    if (value && value.length > 0)
        value.map((item, index) => {
            _value.push(item)

            if (index === location) {
                _value.push(prepareEditorDefaultItem(type))
            }
        })
    else
        _value.push(prepareEditorDefaultItem(type))

    setValue([])

    _value.map((item, index) => {
        setValue(prev => [
            ...prev,
            {
                ...item,
                priority: index
            }
        ])
    })
}